import courseraPlusEpicClient from 'bundles/epic/clients/courseraPlus';

const CTA_TARGET_COURSERA_PLUS_COLLECTIONS_REGEX_PATTERN = '^cplus-collection~[A-Za-z0-9_-]+$';
const CTA_TARGET_COURSERA_PLUS_CHECKOUT_PAGE = 'cplus-checkout-page';

export const isNewCollectionsRolloutEnabled = () => {
  return courseraPlusEpicClient.preview('collectionsRolloutEnabled');
};

export const isCourseraPlusCollectionsCheckoutCtaTarget = (ctaTarget?: string | null) => {
  if (!ctaTarget) return false;
  const regex = new RegExp(CTA_TARGET_COURSERA_PLUS_COLLECTIONS_REGEX_PATTERN);
  const isValid = regex.test(ctaTarget);
  return isValid;
};

const isCourseraPlusCheckoutCtaTarget = (ctaTarget?: string | null) => {
  return ctaTarget === CTA_TARGET_COURSERA_PLUS_CHECKOUT_PAGE;
};

export const isCourseraPlusCheckoutFlowCtaTarget = (ctaTarget?: string | null) => {
  if (!ctaTarget) return false;
  return isCourseraPlusCheckoutCtaTarget(ctaTarget) || isCourseraPlusCollectionsCheckoutCtaTarget(ctaTarget);
};
